import {styled} from '@mui/material';

const LoginLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

export default LoginLayoutContent;
